module.exports = __webpack_public_path__ + "img/hauwa.70396df9.png";